import ContentContainer from "./content/ContentContainer";
import NewsLetterManagement from "./routes/admin/NewsLetterManagement";
import NewsLetterManagementEdit from "./routes/admin/NewsLetterManagementEdit";
import NewsLetterMyAdmin from "./routes/admin/NewsLetterMyAdmin";
import MenuManagement from "./routes/admin/MenuManagement";
import MenuManagementEdit from "./routes/admin/MenuManagementEdit";
import ContentManagement from "./routes/admin/ContentManagement";
import ContentManagementEdit from "./routes/admin/ContentManagementEdit";
import GaleryManagement from "./routes/admin/GaleryManagement";
import MembershipManagement from "./routes/admin/administration/MembershipManagement";
import JuniorManagement from "./routes/admin/administration/JuniorManagement";
import AggregateReport from "./routes/admin/administration/AggregateReport";
import MembershipReportByYear from "./routes/admin/administration/MembershipReportByYear";
import Permission from "./routes/admin/Permission";
import Log from "./routes/admin/Log";
import LogNewsLetter from "./routes/admin/LogNewsLetter";
import MyProfile from "./routes/admin/MyProfile";
import MemberSearch from "./routes/admin/MemberSearch";
import JuniorMyData from "./routes/admin/JuniorMyData";

import ContentById from "./routes/common/ContentById";
import Biokem from "./routes/common/biokem/Biokem";
import NewsLetterSubsription from "./routes/common/NewsLetterSubsription";
import BiokemShow from "./routes/common/BiokemShow";
import Rss from "./routes/common/Rss";
import GaleryList from "./routes/common/GaleryList";
import GaleryById from "./routes/common/GaleryById";
import ForgotPwd from "./routes/common/ForgotPwd";
import JuniorRegistration from "./routes/common/JuniorRegistration";
import VerifyJuniorRegistration from "./routes/common/VerifyJuniorRegistration";

export const routesConfig = [
    {
        path: "/",
        element: <ContentContainer />,
        children: [
            {index: true, path: "", element: <ContentById />},
            {path: "ContentById/:contentId", element: <ContentById />},
            {path: "Biokem/:year", element: <Biokem />},
            {path: "NewsLetterManagement", element: <NewsLetterManagement />},
            {path: "NewsLetterManagementEdit/:id", element: <NewsLetterManagementEdit />},
            {path: "NewsLetterSubsription", element: <NewsLetterSubsription />},
            {path: "NewsLetterMyAdmin", element: <NewsLetterMyAdmin />},
            {path: "BiokemShow/:year/:index/:title", element: <BiokemShow />},
            {path: "MenuManagement/:parentId", element: <MenuManagement />},
            {path: "MenuManagementEdit/:parentId/:id", element: <MenuManagementEdit />},
            {path: "ContentManagement/:parentId", element: <ContentManagement />},
            {path: "ContentManagementEdit/:parentId/:id", element: <ContentManagementEdit />},
            {path: "GaleryManagement", element: <GaleryManagement />},
            {path: "MembershipManagement", element: <MembershipManagement />},
            {path: "JuniorManagement", element: <JuniorManagement />},
            {path: "AggregateReport", element: <AggregateReport />},
            {path: "MembershipReportByYear", element: <MembershipReportByYear />},
            {path: "Permission", element: <Permission />},
            {path: "Log", element: <Log />},
            {path: "LogNewsLetter", element: <LogNewsLetter />},
            {path: "Rss", element: <Rss />},
            {path: "GaleryList", element: <GaleryList />},
            {path: "GaleryById/:id", element: <GaleryById />},
            {path: "MyProfile", element: <MyProfile />},
            {path: "MemberSearch", element: <MemberSearch />},
            {path: "ForgotPwd/:token", element: <ForgotPwd />},
            {path: "JuniorRegistration", element: <JuniorRegistration />},
            {path: "VerifyJuniorRegistration/:token", element: <VerifyJuniorRegistration />},
            {path: "JuniorMyData", element: <JuniorMyData />},
            {path: "*", element: <p>Not found!</p>}
        ]
    }
];

export const getRoutePathList = () => {
    return routesConfig
            .flatMap((route) => route.children?.map((child) => child.path) || [route.path])
            .filter((path) => path && path !== "*")
            .map((path) => "/" + path);
};
